export const PROPERTY_DRAFT = "draft";
export const PROPERTY_PUBLISHED = "published";
export const PROPERTY_RENTED = "rented";
export const PROPERTY_DISABLED = "disabled";
